import React from 'react'
import { Table } from 'react-bootstrap'
import TableCharacter from '../components/TableCharacter.js'
import { useSelector } from "react-redux";
import emptyGif from '../assets/empty.gif'

const FavoriteCharacter = () => {
    const favoriteCharacters = useSelector((state) => state.favoriteReducer.favoriteCharacters)
    if(favoriteCharacters.length === 0) {
        return (
            <>
                <br/>
                <br/>
                <h2>Ooops.. Still Empty</h2>
                <img src={emptyGif} alt=""></img>
            </>
            )
    }
    return (
        <>
            <div >
                <h1>Favorite Character List</h1>
                <div className="container" id="tableCharacter" >
                    <Table striped bordered >
                        <thead>
                            <tr>
                            <th scope="col">#</th>
                            <th scope="col">Character Name</th>
                            <th scope="col">House</th>
                            <th scope="col">Role</th>
                            <th scope="col">School</th>
                            <th></th>
                            </tr>
                        </thead>
                        <tbody >
                        { favoriteCharacters && favoriteCharacters.map((character, index) => (
                            <TableCharacter key={index} mappingCharacter={character} index={index} />
                        )) }
                        </tbody>
                    </Table>
                </div>
            </div>
        </>
    )
}

export default FavoriteCharacter